export default "__VITE_ASSET__DzM0G8bE__"